export default __webpack_public_path__ + "static/media/logo.0ed929e9.png";